"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CloudimageContext = void 0;
var _react = require("react");
var _throttleDebounce = require("throttle-debounce");
var _cloudimageResponsiveUtils = require("cloudimage-responsive-utils");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CloudimageContext = /*#__PURE__*/(0, _react.createContext)({
  cloudImageConfig: {}
});
exports.CloudimageContext = CloudimageContext;
function CloudimageProvider() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    children = _ref.children;
  var _config$token = config.token,
    token = _config$token === void 0 ? '' : _config$token,
    _config$domain = config.domain,
    domain = _config$domain === void 0 ? config.customDomain || 'cloudimg.io' : _config$domain,
    _config$customDomain = config.customDomain,
    customDomain = _config$customDomain === void 0 ? false : _config$customDomain,
    _config$lazyLoading = config.lazyLoading,
    lazyLoading = _config$lazyLoading === void 0 ? false : _config$lazyLoading,
    _config$lazyLoadOffse = config.lazyLoadOffset,
    lazyLoadOffset = _config$lazyLoadOffse === void 0 ? 100 : _config$lazyLoadOffse,
    _config$placeholderBa = config.placeholderBackground,
    placeholderBackground = _config$placeholderBa === void 0 ? '#f4f4f4' : _config$placeholderBa,
    baseUrl = config.baseUrl,
    baseURL = config.baseURL,
    _config$apiVersion = config.apiVersion,
    apiVersion = _config$apiVersion === void 0 ? 'v7' : _config$apiVersion,
    presets = config.presets,
    _config$ratio = config.ratio,
    ratio = _config$ratio === void 0 ? 1.5 : _config$ratio,
    _config$params = config.params,
    params = _config$params === void 0 ? 'org_if_sml=1' : _config$params,
    _config$imageSizeAttr = config.imageSizeAttributes,
    imageSizeAttributes = _config$imageSizeAttr === void 0 ? 'use' : _config$imageSizeAttr,
    _config$exactSize = config.exactSize,
    exactSize = _config$exactSize === void 0 ? false : _config$exactSize,
    _config$doNotReplaceU = config.doNotReplaceURL,
    doNotReplaceURL = _config$doNotReplaceU === void 0 ? false : _config$doNotReplaceU,
    _config$limitFactor = config.limitFactor,
    limitFactor = _config$limitFactor === void 0 ? 100 : _config$limitFactor,
    _config$devicePixelRa = config.devicePixelRatioList,
    devicePixelRatioList = _config$devicePixelRa === void 0 ? _cloudimageResponsiveUtils.CONSTANTS.DEVICE_PIXEL_RATIO_LIST : _config$devicePixelRa,
    _config$lowQualityPre = config.lowQualityPreview,
    _config$lowQualityPre2 = _config$lowQualityPre === void 0 ? {} : _config$lowQualityPre,
    _config$lowQualityPre3 = _config$lowQualityPre2.minImgWidth,
    minImgWidth = _config$lowQualityPre3 === void 0 ? 250 : _config$lowQualityPre3;
  var _useState = (0, _react.useState)({
      token: token,
      domain: domain,
      customDomain: customDomain,
      lazyLoading: lazyLoading,
      lazyLoadOffset: lazyLoadOffset,
      placeholderBackground: placeholderBackground,
      baseURL: baseUrl || baseURL,
      ratio: ratio,
      exactSize: exactSize,
      presets: presets || {
        xs: '(max-width: 575px)',
        // to 575       PHONE
        sm: '(min-width: 576px)',
        // 576 - 767    PHABLET
        md: '(min-width: 768px)',
        // 768 - 991    TABLET
        lg: '(min-width: 992px)',
        // 992 - 1199   SMALL_LAPTOP_SCREEN
        xl: '(min-width: 1200px)' // from 1200    USUALSCREEN
      },

      params: (0, _cloudimageResponsiveUtils.processParams)(params),
      apiVersion: apiVersion,
      innerWidth: typeof window !== 'undefined' ? window.innerWidth : null,
      previewQualityFactor: 10,
      doNotReplaceURL: doNotReplaceURL,
      devicePixelRatioList: devicePixelRatioList,
      limitFactor: limitFactor,
      minLowQualityWidth: minImgWidth,
      imageSizeAttributes: imageSizeAttributes
    }),
    _useState2 = _slicedToArray(_useState, 2),
    cloudImageConfig = _useState2[0],
    setCloudImageConfig = _useState2[1];
  var updateDimensions = (0, _throttleDebounce.debounce)(100, function () {
    setCloudImageConfig(_objectSpread(_objectSpread({}, cloudImageConfig), {}, {
      innerWidth: window.innerWidth
    }));
  });
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateDimensions);
    }
    return function () {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CloudimageContext.Provider, {
    value: (0, _react.useMemo)(function () {
      return {
        cloudImageConfig: cloudImageConfig
      };
    }, [cloudImageConfig]),
    children: children
  });
}
var _default = CloudimageProvider;
exports["default"] = _default;